import {useCallback, useState} from 'react'
import {
    useCreateSessionMutation,
} from 'src/app/appApiQueries'
import {setType} from 'src/app/modal'
import {useAppDispatch, useAppSelector} from 'src/hooks'
import ModalTitle from '../ModalTitle'
import ModalButtons from '../ModalButtons'
import useModalLoading from 'src/hooks/useModalLoading'
import {setCurrentPage} from 'src/app/page'
import {selectMeetingInfo} from 'src/app/meeting'
import {initialState as activeSessionInitialState} from 'src/app/session'
import Input from "../../Input";

export const SessionCreateModal = () => {
    const meetingInfo = useAppSelector(selectMeetingInfo)
    const meetingName = meetingInfo.name
    const [value, setValue] = useState(meetingName || '')
    const dispatch = useAppDispatch()
    const [error, setError] = useState('')
    const [
        createSessionTrigger,
        {isLoading, isSuccess, isError},
    ] = useCreateSessionMutation()

    useModalLoading({
        isLoading: isLoading , // continue to load if we have group data but still no sessionData
        isSuccess: isSuccess,
        isError: isError,
    })

    const onCreate = useCallback(async () => {
        const session = {
            ...activeSessionInitialState,
            ...meetingInfo,
            name: value,
            dateCreated: Date.now(),
        }
        const {id, groupId} = await createSessionTrigger({
            ...session,
            groupId: '',
        }).unwrap()
        dispatch(setCurrentPage({page: 'Session', props: {id, groupId}}))
    }, [
        createSessionTrigger,
        dispatch,
        meetingInfo,
        value,
    ])

    const onCancel = () => {
        dispatch(setType({type: null}))
    }
    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValue(e.target.value)
        // clear an error first if we have one
        if (error) setError('')
        if (e.target.value.length > 30) {
            setError('Must be less than 30 characters')
        }
    }

    return (
        <div>
            <ModalTitle text="Create New Session"/>
            <p aria-label="session-name" className="text-sm">
                Session Name
            </p>
            <Input
                labeledBy="session-name"
                value={value}
                onChange={onChange}
                error={error}
            />

            <ModalButtons
                firstButton={{
                    name: 'Cancel',
                    type: 'secondary',
                    onClick: onCancel,
                    htmlButtonType: 'button',
                }}
                secondButton={{
                    name: 'Create',
                    type: 'primary',
                    onClick: onCreate,
                    disabled: !value,
                    htmlButtonType: 'button',
                }}
            />
        </div>
    )
}
